import { useMemo } from "react";
import { useCartTotal } from "./useCartHook";
import usePosOrderCustomDiscount from "../atoms/usePosOrderCustomDiscount";

const useCustomDiscountValue = () => {
  const cartTotal = useCartTotal();
  const [discount] = usePosOrderCustomDiscount();

  const value: number = useMemo(() => {
    if (discount?.type) {
      return discount.type === 1
        ? (cartTotal * discount.percentage_discount) / 100
        : discount.fixed_price_discount;
    } else {
      return 0;
    }
  }, [cartTotal, discount]);

  return value;
};

export default useCustomDiscountValue;
